import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SharedActionTypes, StepChangedOnSave } from '@icc/configurator/shared';
import { map } from 'rxjs/operators';
import { MeasurementsService } from '../modules/dimensions/measurements.service';

@Injectable()
export class WindowDoorEffects {

    stepChangedOnSave$ = createEffect(() => this.actions$.pipe(
        ofType<StepChangedOnSave>(SharedActionTypes.StepChangedOnSave),
        map((payload) => {
            this.measurementsService.measurements = [];
        })
    ), {
        dispatch: false
    });

     constructor(
        private actions$: Actions,
        private measurementsService: MeasurementsService,
     ) {}
}

// Legacy export
export const WindowEffects = WindowDoorEffects;
